import { AddressInfo } from "net";
import { HistoryModel } from "../../common/models/global.typing";
import { RecordInfo } from "../../common/models/RecordInfo";
import { ContactInfo, PhoneModel } from "../../home/models/ContactInfo";
import { OrderModel, OrderRequestType } from "../../orders/models/OrderModel";
import { WarehouseModel } from "../../products/models/WarehouseModel";

export enum PaymentRequirement {
    beforeDelivery = 0,
    atDelivery = 1,
    atDeliveryOrLater = 2,
    later = 3
}

export enum InvoiceType {
    all = 0,
    sale = 1,
    return = 2,
    writeOff = 3
}

export enum InvoiceStatus {
    all = 0,
    pending = 1,
    processing = 2,
    itemsReady = 3,
    confirmed = 4,
    readyForDelivery = 5,
    outForDelivery = 6,
    completed = 7,
}

export enum PackageType {
    box = 1,
    flatBox = 2,
    companyBag = 3,
    plasticBag = 4,
    other = 5
}

export interface BankAccountModel {
    id: number;
    provider: string;
    account: string;
    name: string;
    qrCode?: string;
    description?: string;
    active: boolean;
    deleted: boolean;
    isPayByPhone: boolean;
    order: number;
    imageUrl?: string;
}

export interface PrintInvoiceModelWrapper {
    invoices: InvoiceDetailModel[];
    contacts: ContactInfo[];
    bankAccounts: BankAccountModel[];
    note?: string;
    rielsExchangeRate: number;
}

export interface PrintInvoiceLabelWrapper {
    senderNumber: string;
    rielsExchangeRate: number;
    invoices: PrintInvoiceLabelModel[];
}

export interface PrintInvoiceLabelModel {
    id: string;
    customer: string;
    balance: number;
    paymentRequirement: PaymentRequirement;
    date: Date;
    deliveryMethod: string;
    requestType: OrderRequestType;
    requestDate: Date;
    packageType: PackageType;
    phone: PhoneModel;
    address: string;
    consolidated: boolean;
}

export interface EditInvoiceModel {
    shipping: number;
    customerPayShipping: boolean;
    note: string;
    forced: boolean;

    // Only for Bees
    shippingRate: number;

    // Only for Bees
    chargeWeight: number;
}

export interface InvoiceDetailModelBase extends EditInvoiceModel {
    id: string;
    customerId: number;
    warehouseId: number;
    addressId?: number;
    phoneId?: number;
    amount: number;
    total: number;
    paid: number;
    apply: number;
    date: Date;
    type: InvoiceType;
    status: InvoiceStatus;

    customerRequested: boolean;
    phoneConfirmed: boolean;
    addressConfirmed: boolean;
    itemsConfirmed: boolean;

    packageType: PackageType;
    deliveryMethod?: string;
    paymentRequirement: PaymentRequirement;
    requestType: OrderRequestType;

    consolidated: boolean;
    requestDate: string;

    customer: string;
    displayName?: string;
    userId?: string;

    recordInfo: RecordInfo;
    backgroundColor?: string;
    phone?: PhoneModel;
    addressLine?: string;
    address?: AddressInfo;
    warehouse: WarehouseModel;
    earningPoints: number;
    histories: HistoryModel[];
    confirmedWithCustomer: boolean;
}

export interface InvoiceDetailModel extends InvoiceDetailModelBase {
    items: OrderModel[];
}
export interface ShortInvoiceModel {
    id: string;

    customerId: number;
    customer: string;
    userId?: string;

    warehouseId: number;
    warehouse?: string;

    addressConfirmed: boolean;
    phoneConfirmed: boolean;
    itemsConfirmed: boolean;
    customerRequested: boolean;

    amount: number;
    shipping: number;

    date: Date;

    deliveryMethod?: string;
    note?: string;

    packageType: PackageType;
    paymentRequirement: PaymentRequirement;

    consolidated: boolean;
    customerPayShipping: boolean;

    addressId?: number;
    phoneId?: number;
    countryCode?: string;
    phoneNo?: string;

    status: InvoiceStatus;
    type: InvoiceType;

    total: number;
    paidAmount: number;

    requestType: OrderRequestType;
    requestDate: string;

    items: OrderModel[];
    confirmedWithCustomer: boolean;
}

export interface CustomerInvoiceChangeModel {
}